import ODDiOrdering from "./ODDiOrdering";

export default {
  __init__: ["odDiOrdering"],
  odDiOrdering: ["type", ODDiOrdering],
};
